import type { LegalDocumentContent } from './types';

export const termsIosContent: LegalDocumentContent = {
  title: 'Terms & Conditions',
  intro:
    'These terms apply to the LuvLust iOS app and subscription purchases made through the Apple App Store.',
  sections: [
    {
      title: '1. Acceptance of Terms',
      paragraphs: [
        'By downloading, installing, or using our app, you agree to be bound by these terms and conditions. If you do not agree to these terms, please do not use the app.',
      ],
    },
    {
      title: '2. Contracting the Services',
      paragraphs: [
        'In order to use premium services, you must be of legal age and use the Apple App Store to download and purchase within the app.',
        'Once the application has been downloaded, when starting it for the first time, you may optionally answer questions related to general data linked to the application. All this information can be modified at any time through the corresponding configuration panel.',
        'You have a free version with limited content. To enjoy all content, you may subscribe to Premium through recurring payment plans (weekly, monthly, or annual) offered in the app.',
      ],
    },
    {
      title: '3. Price and Period of Validity',
      paragraphs: [
        'LuvLust will inform you prior to purchase, through the App Store and within the app, the price of available services. These prices, unless expressly stated otherwise, do not include communication costs or any other additional services.',
      ],
    },
    {
      title: '4. Subscription Plans',
      paragraphs: [
        'LuvLust on iOS offers auto-renewing subscriptions for ongoing access to premium content.',
      ],
      listItems: [
        'Weekly, monthly, or annual billing periods may be offered',
        'The full billed amount and billing period are shown before you confirm purchase',
        'Introductory offers or free trials, when available, are disclosed at checkout',
      ],
    },
    {
      title: '5. Payment Methods and Security',
      paragraphs: [
        'Payments are processed by Apple through your Apple ID. We do not have access to your payment information and do not store such information.',
        'Apple App Store terms apply: https://www.apple.com/legal/internet-services/itunes/',
      ],
    },
    {
      title: '6. Applicable Taxes',
      paragraphs: [
        'All prices shown are final prices at the time of purchase, subject to applicable taxes as determined by Apple.',
      ],
    },
    {
      title: '7. Price Changes',
      paragraphs: [
        'LuvLust reserves the right to modify subscription prices. When you subscribe, you are initially charged the rate that applies at the time you subscribe. If the subscription price increases later, you will be notified in accordance with App Store policies.',
      ],
    },
    {
      title: '8. Invoicing',
      paragraphs: [
        'Once payment has been made, Apple provides the corresponding receipt or proof of purchase.',
      ],
    },
    {
      title: '9. Subscriptions, Trials, and Cancellation',
      paragraphs: [
        'By subscribing, you obtain access to premium content on an ongoing basis unless you cancel. Subscriptions automatically renew at the beginning of each billing period unless auto-renew is turned off at least 24 hours before the end of the current period.',
        'When you subscribe, you may be offered a free trial period. After the trial ends, you will be charged until you cancel.',
        'You can cancel anytime through your Apple ID subscription settings. Cancellation takes effect at the end of the current billing period.',
        'You can restore purchases using the "Restore Purchases" option in the app with the same Apple ID.',
      ],
    },
    {
      title: '10. Contact',
      paragraphs: ['Questions about these terms: starlitapps.dev@gmail.com'],
    },
  ],
};
